module.exports = __webpack_public_path__ + "static/img/wisdom3.7fc28dfa.png";